module.exports = __webpack_public_path__ + "static/media/Doc1.6432eb89.jpg";